export default class Slider {
  
  constructor() {
    const cardSliderLg = document.querySelector('.card-slider-lg'),
    cardSlider = document.querySelector('.card-slider');
    
    if (cardSliderLg) {
      this.initCardSliderLg();
    }
    
    if (cardSlider) {
      this.initCardSlider($(cardSlider));
    }
    
    this.addResizeListener();
  }
  
  initCardSliderLg() {
    const cardSliderLg = $('.card-slider-lg');
    
    cardSliderLg.on('afterChange', function (event, slick, currentSlide) {
      $('.slide-icon').removeClass('active');
      $('.slide-icon[data-slide-index="' + currentSlide + '"]').addClass('active');
    });
    
    // Set initial active icon
    $('.slide-icon[data-slide-index="0"]').addClass('active');
    
    cardSliderLg.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      centerMode: true,
      centerPadding: '17%',
      appendDots: '#dots-container-lg',
      touchThreshold: 10
    });
    
    $('.slider-prev')
    .off('click.slider')
    .on('click.slider', (e) => {
      e.preventDefault();
      cardSliderLg.slick('slickPrev');
    });
    
    $('.slider-next')
    .off('click.slider')
    .on('click.slider', (e) => {
      e.preventDefault();
      cardSliderLg.slick('slickNext');
    });
    
    $('.slide-icon')
    .off('click.slider')
    .on('click.slider', function (e) {
      e.preventDefault();
      cardSliderLg.slick('slickGoTo', $(this).data('slide-index'));
    });
  }
  
  initCardSlider(cardSlider) {
    cardSlider.slick({
      autoplay: true,
      dots: true,
      arrows: false,
      speed: 1500,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '8%',
      appendDots: '#dots-container',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            arrow: false,
            dots: true,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            arrow: false,
            dots: true,
            centerMode: false,
          },
        },
      ],
    });
    
    $('.btn-slider-card.slider-prev')
    .off('click.slider')
    .on('click.slider', (e) => {
      e.preventDefault();
      cardSlider.slick('slickPrev');
    });
    
    $('.btn-slider-card.slider-next')
    .off('click.slider')
    .on('click.slider', (e) => {
      e.preventDefault();
      cardSlider.slick('slickNext');
    });

    const toggle = document.querySelector('.slider-toggle');
    let isPaused = false;
    
    toggle.addEventListener('click', () => {
      isPaused = !isPaused;
      
      if (isPaused) {
        cardSlider.slick('slickPause');
        toggle.setAttribute('aria-label', 'Play slideshow');
        toggle.setAttribute('aria-pressed', 'true');
        toggle.querySelector('span').className = 'fa-regular fa-circle-play text-pink fa-2x';
      } else {
        cardSlider.slick('slickPlay');
        toggle.setAttribute('aria-label', 'Pause slideshow');
        toggle.setAttribute('aria-pressed', 'false');
        toggle.querySelector('span').className = 'fa-regular fa-circle-pause text-pink fa-2x';
      }
    });
  }
  
  addResizeListener() {
    window.addEventListener('resize', () => {
      clearTimeout(this.resizeTimeout);
      
      this.resizeTimeout = setTimeout(() => {
        if ($('.card-slider-lg').length) {
          $('.card-slider-lg').slick('setPosition');
        }
      }, 250);
    });
  }
}